import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {
  _checkTokens,
  _checkErrors,
  _tryOrRefresh,
  I_COMMON_GET_ALL_PARAMS,
  I_COMMON_GET_ITEM_PARAMS,
  I_COMMON_DELETE_PARAMS,
  I_COMMON_IMPORT_PARAMS,
  I_COMMON_CREATE_PARAMS,
  I_COMMON_PUT_PARAMS,
} from './_base';

import {I_CHARGE_MODEL,I_CHARGE_ACTIVITY_MODEL} from '../interfaces/I_CHARGE_MODELS';
import {
  getChargesModelsResponse,
  postChargeModelResponse,
  deleteChargeModelResponse,
  getChargeModelResponse,
  putChargeModelResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- MODELS DE CHARGES
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  directions_hr: string;  // direction de l'activité de la charge
  hubs_hr: string;  // pole de direction de l'activité de la charge

  collaborators: string;
  skills: string;
  functions: string;
}
interface I_CHARGE_MODEL_FIELDS {
  /** nom du modele de charge */
  name: string;
  /** description du modele de charge (opt.) */
  description?: string;
  /** type d'activité du modele de charge (opt.) */
  activity_type_id?: number;
  /** volume horaire du modele de charge (opt.) */
  hourly_volume?: number;
  /** direction OPS du modele de charge (opt.) */
  direction?: string;
  /** pole de direction OPS du modele de charge (opt.) */
  hub?: string;
  /** liste des activités du modele de charge (peut etre vide) */
  activities: I_CHARGE_ACTIVITY_MODEL[];
}
interface I_CREATE_CHARGE_MODEL_PARAMS extends I_COMMON_CREATE_PARAMS, I_CHARGE_MODEL_FIELDS {}
interface I_PUT_CHARGE_MODEL_PARAMS extends I_COMMON_PUT_PARAMS, I_CHARGE_MODEL_FIELDS {}


// ----

const isMissingField = (item:I_CHARGE_MODEL_FIELDS) => {
  const nameKO = !item.name || item.name === null || item.name.trim() === '';
  const descriptionKO = false;
  const activitytypeKO = false;
  const hourlyvolumeKO = false;
  const directionKO = false;
  const hubKO = false;
  const chargeKO = nameKO || descriptionKO || activitytypeKO || hourlyvolumeKO || directionKO || hubKO;

  let activitiesKO = false;
  item.activities.forEach((activity:I_CHARGE_ACTIVITY_MODEL) => {
    const anameKO = !activity.name || activity.name === null || activity.name.trim() === '';
    const avolumeKO = activity.value_volume === undefined || activity.value_volume === null || activity.value_volume <= 0;
    if (anameKO || avolumeKO) {
      activitiesKO = true;
    }
    if (anameKO || avolumeKO) {
      logger.debug('Missing field on activity',{
        item,
        value_volume: activity.value_volume,
        anameKO,
        avolumeKO,
      });
    }
  });

  if (chargeKO) {
    logger.debug('Missing field on charge',{
      item,
      nameKO,
      descriptionKO,
      activitytypeKO,
      hourlyvolumeKO,
      directionKO,
      hubKO,
    });
  }

  return chargeKO || activitiesKO;
}

// ----



/**
 * Récupère la liste des modeles de charge
 * @param obj
 * @returns
 */
const getList = async ({
  accessToken,refreshToken,dispatch,state,
  page,
  activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,
}:I_GET_PARAMS):Promise<I_CHARGE_MODEL[]> => {
  logger.debug('ApiServices - getChargesModels - ',{page});
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getChargesModelsResponse({
        accessToken:usedAccessToken,page,
        activity_types,directions_ops,hubs_ops,directions_hr,hubs_hr,collaborators,
        skills,functions,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getChargesModels - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_CHARGE_MODEL[] = await response.json();
  logger.debug('ApiServices - getChargesModels - ok, returned body',body);
  return body;
};

/**
 * Crée un modele de charge
 * @param param0
 * @returns
 */
const create = async (args:I_CREATE_CHARGE_MODEL_PARAMS):Promise<string> => {
  logger.debug('ApiServices - createChargeModel - ...');
  const {
    accessToken,refreshToken,
    dispatch,state,
    name, description, activity_type_id, hourly_volume, direction, hub, activities,
  } = args;
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (isMissingField(args)) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to post new charge model',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postChargeModelResponse({
        accessToken:usedAccessToken,
        name,description,
        activity_type_id,
        hourly_volume,
        direction,hub,
        activities,
      });
    },
    accessToken,
    refreshToken,
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - createChargeModel - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - createChargeModel - ok, returned body',body);
  logger.info(...formatInfo('Charge model created!'));
  return body;
};

/**
 * Supprime un modele de charge
 * @param param0
 * @returns
 */
const remove = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_DELETE_PARAMS):Promise<string> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - deleteChargeModel - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteChargeModelResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - deleteChargeModel - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - deleteChargeModel - ok, returned body',body);
  logger.info(...formatInfo('Charge model deleted!'));
  return body;
};


/**
 * Modifie un modele de charge
 * @param param0
 * @returns
 */
const update = async (args:I_PUT_CHARGE_MODEL_PARAMS):Promise<string> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - updateChargeModel - ...');
  const {
    accessToken,refreshToken,
    dispatch,state,
    id,
    name, description, activity_type_id, hourly_volume, direction, hub, activities,
  } = args;
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (isMissingField(args)) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing field(s)',
      errorMessage: 'Missing field(s) to update charge model',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putChargeModelResponse({
        accessToken:usedAccessToken,
        id,
        name,description,
        activity_type_id,
        hourly_volume,direction,hub,
        activities,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - updateChargeModel - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateChargeModel - ok, returned body',body);
  logger.info(...formatInfo('Charge model updated!'));
  return body;
};

/**
 * Récupère la charge
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_GET_ITEM_PARAMS) => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - getChargeModel - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getChargeModelResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getChargeModel - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_CHARGE_MODEL = await response.json();
  logger.debug('ApiServices - getChargeModel - ok, returned body',body);
  return body;
};



const chargesServices = {
  getList,
  create,
  remove,
  update,
  getItem,
};

export default chargesServices;
